import dayjs from 'dayjs';
import getOffsetTime from '../../../../../utils/getOffsetTime.js';


const editAssignment = (itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId) => {
  let updatedResource;

  if (itemDetails.status === 10) {
    // standby assignment, must create dayType to house assignment
    const { dayTypeId, assignmentStartTime, assignmentEndTime, activityType,
    jobId, jobNumber, serviceName, costObject, status, descriptionComment, employeeComment, approverComment } = itemDetails;
    const tempJobElementId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;

    let startTime = dayjs(assignmentStartTime);
    let timeZoneOffset = getOffsetTime(assignmentStartTime);
    
    startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
    let endTime = dayjs(assignmentEndTime).subtract(timeZoneOffset, 'minute').unix();

      // create udpated assignment
    const assignment = {
      jeId: tempJobElementId,
      startTime,
      endTime,
      service: serviceName,
      activityType,
      requestNumber: jobNumber,
      jobId,
      costObject: costObject.costObjectName,
      costObjectNumber: costObject.costObjectNumber,
      description: descriptionComment,
      myAssignmentComment: employeeComment,
      comment: null, // scheduler comment??
      jeStatus: status,
      isApproved: false // can't find anywhere???
    };
    // create assignment-dayType (not a dayType in STORM desktop, just created to house standby assignment on the frontend)
    const dayType = {
      rdtId: tempJobElementId,
      dayStart: "0",
      assignment
    };
    // updatedResource =  *** put the updateResource code here... // might be need to be slightly different for each case in this file...
    return updatedResource;

  }
  // else if (itemDetails.addTourForAssignment) {
  //     // create assignment
  //     const { assignmentStartTime, assignmentEndTime, activityType,
  //     jobId, jobNumber, serviceName, costObject, status, descriptionComment } = itemDetails;
  //     const tempJobElementId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;

  //     let timeZoneOffset = getOffsetTime(assignmentStartTime);
  //     let startTime = dayjs(assignmentStartTime).clone();
  //     startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
  //     let endTime = dayjs(assignmentEndTime).clone();
  //     endTime = endTime.subtract(timeZoneOffset, 'minute').unix();

  //     const assignment = {
  //       jeId: tempJobElementId,
  //       startTime,
  //       endTime,
  //       service: serviceName,
  //       activityType,
  //       requestNumber: jobNumber,
  //       jobId,
  //       costObject: costObject.costObjectName,
  //       costObjectNumber: costObject.costObjectNumber,
  //       description: descriptionComment,
  //       myAssignmentComment: null,
  //       comment: null, // scheduler comment
  //       jeStatus: status,
  //       isApproved: false // just created, can't be approved yet
  //     };

  //     const { dayTypeId, tourStartTime, tourEndTime, mealStartTime } = itemDetails;
  //     const { notification, comment, comment15  } = itemDetails.tourParams;
  //     const tempDayTypeId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;
  //     const tempTourId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;
  //     const tempMealId = `${Math.floor(Math.random() * (9999999 - 9000000 + 1)) + 9000000}-optimistic`;

  //     timeZoneOffset = getOffsetTime(tourStartTime);
  //     startTime = dayjs(tourStartTime).clone();
  //     startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
  //     let mealStartTimeUnix = dayjs(mealStartTime).clone();
  //     mealStartTimeUnix = mealStartTimeUnix.subtract(timeZoneOffset, 'minute').unix();
  //     let mealEndTimeUnix = dayjs(mealStartTime).clone();
  //     mealEndTimeUnix = mealEndTimeUnix.subtract(timeZoneOffset - 60, 'minute').unix();  // all meal an hour for now
  //     // create new dayType, tour and meal
  //     const tour = {
  //       tourId: tempTourId,
  //       startTime,
  //       duration: dayjs.duration(tourEndTime.diff(tourStartTime)).asHours(),
  //       notificationComment: notification,
  //       tourComment: comment,
  //       myTourComment: comment15,
  //       tourIndicators: [],
  //       tourPayTransactions: [],
  //       meal: {
  //         mealId: tempMealId,
  //         mealTime: mealStartTimeUnix,
  //         mealEndTime: mealEndTimeUnix,
  //         red: false
  //       },
  //       assignments: {
  //         [assignment.jeId]: assignment
  //       }
  //     };
  //     const dayType = {
  //       rdtId: tempDayTypeId,
  //       title: dayTypesAllowTour.find((elem) => elem.id == dayTypeId).name,
  //       dayOff: null,
  //       tour
  //     };
  //     return dayType;

  // } else if (itemDetails.editTourForAssignment) {
  //     // create assignment
  //     const { assignmentStartTime, assignmentEndTime, activityType,
  //     jobId, jobNumber, serviceName, costObject, status, descriptionComment } = itemDetails;
  //     const tempJobElementId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;

  //     let timeZoneOffset = getOffsetTime(assignmentStartTime._d);
  //     let startTime = dayjs(assignmentStartTime).clone();
  //     startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
  //     let endTime = dayjs(assignmentEndTime).clone();
  //     endTime = endTime.subtract(timeZoneOffset, 'minute').unix();

  //     const assignment = {
  //       jeId: tempJobElementId,
  //       startTime,
  //       endTime,
  //       service: serviceName,
  //       activityType,
  //       requestNumber: jobNumber,
  //       jobId,
  //       costObject: costObject.costObjectName,
  //       costObjectNumber: costObject.costObjectNumber,
  //       description: descriptionComment,
  //       myAssignmentComment: null,
  //       comment: null, // scheduler comment
  //       jeStatus: status,
  //       isApproved: false // just created, can't be approved yet
  //     };

  //     const { tourId, rdtId, dayTypeId, tourStartTime, tourEndTime, mealStartTime } = itemDetails;
  //     const { notification, comment, comment15  } = itemDetails.tourParams;
  //     // const { mealId, mealStart, mealEnd, } = itemDetails.tourDetails.meals[0];
  //     const tempRdtId = `${rdtId}-optimistic`;
  //     const tempTourId = `${tourId}-optimistic`;
  //     // const tempMealId = `${mealId}-optimistic`;

  //     timeZoneOffset = getOffsetTime(tourStartTime._d);
  //     // console.log(`rdtId: ${rdtId}`); // debug
  //     // console.log(`tourId: ${tourId}`); // debug
  //     // console.log(timeZoneOffset); // debug
  //     startTime = dayjs(tourStartTime).clone();
  //     // console.log(startTime); // debug
  //     startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
  //     // let mealTime = dayjs(mealStartTime).clone().add(4, 'hour').unix();
  //     // create new dayType, tour and meal
  //     const tour = {
  //       tourId: tempTourId,
  //       startTime,
  //       duration: dayjs.duration(tourEndTime.diff(tourStartTime)).asHours(),
  //       notificationComment: notification,
  //       tourComment: comment,
  //       myTourComment: comment15,
  //       tourIndicators: [],
  //       tourPayTransactions: [],
  //       // meal: {
  //       //   mealId: tempMealId,
  //       //   mealTime,
  //       //   red: false
  //       // },
  //       assignments: {
  //         [assignment.jeId]: assignment
  //       }
  //     };
  //     // build new resource obj which will house dayTypes array, which houses tour obj
  //     const origResource = optimisticLiveSchedule.find((elem) => resourceId == elem.rId);
  //     const resource = JSON.parse(JSON.stringify(origResource));
  //     if (resource.dayTypes[rdtId]) {
  //       // create and populate new dayType
  //       resource.dayTypes[tempRdtId] = {};
  //       resource.dayTypes[tempRdtId].rdtId = tempRdtId;
  //       resource.dayTypes[tempRdtId].dayTypeId = dayTypeId
  //       resource.dayTypes[tempRdtId].title = dayTypesAllowTour.find((elem) => elem.id == dayTypeId).name;
  //       resource.dayTypes[tempRdtId].tour = tour;
  //       // *** NEW *** copy existing assignments (if any)
  //       if (resource.dayTypes[rdtId].tour) {
  //         resource.dayTypes[tempRdtId].tour.assignments = resource.dayTypes[rdtId].tour.assignments;
  //         // insert just-created assignment into assignments object
  //         resource.dayTypes[tempRdtId].tour.assignments[assignment.jeId] = assignment;
  //       }
  //       // delete old dayType
  //       delete resource.dayTypes[rdtId];
  //     }
  //     return resource;
  // }
}

export default editAssignment;

// const updateResource

// const editDayType = (itemDetails, optimisticLiveSchedule, dayTypesAll, dayTypesAllowTour, resourceId) => {
//   const { dayTypeId, resourceDayType, dayTypeComment, myDayTypeComment } = itemDetails;
//   const { resourceDayTypeId } = resourceDayType;
//   const tempRdtId = `${resourceDayTypeId}-optimistic`;
//   const title =  dayTypesAll.find((elem) => dayTypeId == elem.dayTypeId) ? dayTypesAll.find((elem) => dayTypeId == elem.dayTypeId).dayTypeName : dayTypesAllowTour.find((elem) => dayTypeId == elem.id) ? dayTypesAllowTour.find((elem) => dayTypeId == elem.id).name : null
//    // address cloud server utc time offset (4 hours)
//   const origResource = optimisticLiveSchedule.find((elem) => resourceId === elem.rId);
//   const resource = JSON.parse(JSON.stringify(origResource));
//   // resource.dayTypes[resourceDayTypeId].rdtId = (resource.dayTypes[resourceDayTypeId].rdtId).toString + '-optimistic';
//   if (resource.dayTypes[resourceDayTypeId]) {
//     // create and populate new dayType obj
//     resource.dayTypes[tempRdtId] = {};
//     resource.dayTypes[tempRdtId].rdtId = tempRdtId;
//     resource.dayTypes[tempRdtId].dayTypeId = dayTypeId
//     resource.dayTypes[tempRdtId].title = title;
//     resource.dayTypes[tempRdtId].dayTypeComment = dayTypeComment;
//     resource.dayTypes[tempRdtId].myDayTypeComment = myDayTypeComment;
//       if (resource.dayTypes[resourceDayTypeId].dayOff) {
//         const { startTime, endTime, } = resource.dayTypes[resourceDayTypeId].dayOff;
//         // create and populate new dayOff obj
//         resource.dayTypes[tempRdtId].dayOff = {};
//         resource.dayTypes[tempRdtId].dayOff.dorId = dayTypeId;  // not sure this is accurate
//         resource.dayTypes[tempRdtId].dayOff.title = title;
//         resource.dayTypes[tempRdtId].dayOff.startTime = startTime;
//         resource.dayTypes[tempRdtId].dayOff.endTime = endTime;
//         resource.dayTypes[tempRdtId].dayOff.dayTypeComment = dayTypeComment;
//         resource.dayTypes[tempRdtId].dayOff.myDayTypeComment = myDayTypeComment;
//       }
//       if (resource.dayTypes[resourceDayTypeId].tour) {
//         // create and populate new tour obj
//         resource.dayTypes[tempRdtId].tour = resource.dayTypes[resourceDayTypeId].tour;
//       }

//     // delete old dayType
//     delete resource.dayTypes[resourceDayTypeId];
//   }
//   return resource;
// }
